import { useQuery } from '@tanstack/react-query'
import { getNotificationCards } from '@/modules/Notifications/NotificationsServiceHelper'
import NotificationCard from './NotificationCard'

type Props = {
  totalCards: number
}

export const NotificationCards: React.FC<Props> = ({ totalCards }) => {
  // 🔥Get user profile
  const { isLoading, data: notificationCards } = useQuery(
    ['notificationCards'],
    () => {
      return getNotificationCards()
        .then((cards) => {
          return cards['hydra:member']
        })
        .catch((error) => {
          console.error('Error fetching notifications cards', error)
        })
    },
    {
      refetchOnWindowFocus: false,
      staleTime: 10000,
    },
  )

  return (
    <>
      {!isLoading &&
        notificationCards &&
        notificationCards.map((card) => (
          <NotificationCard
            iconClassName={card.icon.type}
            title={card.title}
            subtitle={card.subtitle}
            buttonLabel={card.button.label}
            buttonVariant={card.button.variant}
            buttonColor={card.button.type}
            linkHref={card.button.url}
            linkRelative={card.button.relative}
            totalCards={totalCards}
          />
        ))}
    </>
  )
}
